module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-wrap"
  }, [_c('mu-appbar', {
    staticClass: "top-nav",
    attrs: {
      "zDepth": 0
    }
  }, [_c('mu-avatar', {
    attrs: {
      "slot": "left",
      "src": _vm.avatar,
      "size": 30
    },
    on: {
      "click": function($event) {
        return _vm.showSidebar_x(true)
      }
    },
    slot: "left"
  }), _vm._v(" "), _c('div', {
    staticClass: "title",
    attrs: {
      "slot": "default"
    },
    slot: "default"
  }, [_c('div', {
    staticClass: "title-item"
  }, [_vm._v(_vm._s(_vm.headerTitle))])]), _vm._v(" "), _c('mu-icon', {
    attrs: {
      "slot": "right",
      "value": "search",
      "color": "#2e2c6b"
    },
    on: {
      "click": _vm.showSearch
    },
    slot: "right"
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c7c7a88a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/topnav/top-nav.vue
// module id = 528
// module chunks = 1